import { call, Effect, takeLatest } from 'redux-saga/effects';
import { types as dashboardMaintenanceTypes, actions as dashboardMaintenanceActions } from 'ducks/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';
import { callApi } from '../utils';
import { IDataAction } from 'ducks/utils';
import * as api from 'api/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';

function* search(action: IDataAction): IterableIterator<Effect> {
  const { success, failure } = dashboardMaintenanceActions.saga.search;
  yield callApi(
    call(api.search, action.data),
    success,
    failure
  );
}

function* searchById(action: IDataAction): IterableIterator<Effect> {
  const { success, failure } = dashboardMaintenanceActions.saga.searchById;

  yield callApi(
    call(api.searchById, action.data),
    success,
    failure
  );
}

function* fetchNext(action: IDataAction): IterableIterator<Effect> {
  const { success, failure } = dashboardMaintenanceActions.saga.fetchNextPage;

  yield callApi(
    call(api.search, action.data),
    success,
    failure
  );
}

function* fetchPrev(action: IDataAction): IterableIterator<Effect> {
  const { success, failure } = dashboardMaintenanceActions.saga.fetchPrevPage;

  yield callApi(
    call(api.search, action.data),
    success,
    failure
  );
}

export default function* rootCustomerSaga(): IterableIterator<Effect> {
  yield takeLatest(dashboardMaintenanceTypes.search, search);
  yield takeLatest(dashboardMaintenanceTypes.searchById, searchById);
  yield takeLatest(dashboardMaintenanceTypes.fetchPrevPage, fetchPrev);
  yield takeLatest(dashboardMaintenanceTypes.fetchNextPage, fetchNext);
}
